const trackSearch = searchTerm => {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'AppDirectorySearch',
    data: {
      search: searchTerm,
    },
  });
};

const trackCategoryClick = categorySlug => {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'AppDirectoryCategoryClick',
    data: {
      slug: categorySlug,
    },
  });
};

const trackTileClick = (appSlug, selectedCategory, searchTerm) => {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'AppDirectoryTileClick',
    data: {
      app_slug: appSlug,
      selected_category_slug: selectedCategory,
      search_term: searchTerm,
    },
  });
};

const trackListingConnectClick = appSlug => {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'AppDirectoryListingConnectClick',
    data: {
      slug: appSlug,
    },
  });
};

const trackListingReferralClick = (appSlug, hasDiscount) => {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'AppDirectoryListingReferralClick',
    data: {
      slug: appSlug,
      has_discount: hasDiscount,
    },
  });
};

const trackPartnerWebsiteClick = appSlug => {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'AppDirectoryListingPartnerWebsiteClick',
    data: {
      slug: appSlug,
    },
  });
};

const trackPartnerPricingClick = appSlug => {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'AppDirectoryListingPartnerPricingClick',
    data: {
      slug: appSlug,
    },
  });
};

const trackPartnerHelpClick = appSlug => {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'AppDirectoryListingPartnerHelpClick',
    data: {
      slug: appSlug,
    },
  });
};

const trackPartnerTermsOfServiceClick = appSlug => {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'AppDirectoryListingPartnerTermsOfServiceClick',
    data: {
      slug: appSlug,
    },
  });
};

const trackDemoCarouselNextOrPrev = appSlug => {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'AppDirectoryListingDemoItemNextOrPrev',
    data: {
      slug: appSlug,
    },
  });
};

const trackDemoVideoAction = (appSlug, action) => {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'AppDirectoryListingDemoVideoAction',
    data: {
      slug: appSlug,
      action,
    },
  });
};

export {
  trackSearch,
  trackCategoryClick,
  trackTileClick,
  trackListingConnectClick,
  trackListingReferralClick,
  trackPartnerWebsiteClick,
  trackPartnerPricingClick,
  trackPartnerHelpClick,
  trackPartnerTermsOfServiceClick,
  trackDemoCarouselNextOrPrev,
  trackDemoVideoAction,
};
